













































































































































import { Component, Vue } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import _ from "lodash";
import GlobalMixins from "../../global.mixin";
import DateRangePicker from "../../components/DateRangePicker.vue";
import { importExportApi } from "../../services/api/importexport.api";


@Component({
  mixins: [GlobalMixins],
  components: {
    DateRangePicker
  }
})
export default class InventoryReportView extends Vue {
  @State("inventoryReports") inventoryReportsState: any;
  @Action("getInventoryReports") getInventoryReports: any;

  search = "";
  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "createdDate",
    descending: true,
    page: 1,
    rowsPerPage: (this as any).$cookies.isKey("inventory-reports-rowsPerPage") ?
                        parseInt((this as any).$cookies.get("inventory-reports-rowsPerPage"), 10) : 25
  };

  showFilters = false;
  filters = {
    "createdDate": { from: "", to: "" },
    "origSite.code": "",
    "origSite.description": "",
    "origCostCenter.code": "",
    "origCostCenter.description": "",
    "site.code": "",
    "site.description": "",
    "newCostCenter.code": "",
    "newCostCenter.description": "",
    "product.description": "",
    "product.productCode": "",
    "product.barCode": "",
    "historyType": "",
    "note": ""
  };

  serversideSearch = _.debounce(() => {
    this.updatePagination(this.pagination);
  }, 300);


  getHeaders() {
    return [
      {
        text: "#",
        value: "inventoryItemId",
        filterCol: "inventoryItemId",
        width: "1%",
        align: "left",
        filterable: false,
        filterType: "none"
      },
      {
        text: "Dátum",
        value: "createdDate",
        filterCol: "createdDate",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "dateRange"
      },
      {
        text: "Eredeti Telephely",
        value: "origSite.code",
        filterCol: "origSite.code",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: "Eredeti Tlph Leírás",
        value: "origSite.description",
        filterCol: "origSite.description",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: "Eredeti Ktsg Kód",
        value: "origCostCenter.code",
        filterCol: "origCostCenter.code",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: "Eredeti Ktsg Leírás",
        value: "origCostCenter.description",
        filterCol: "origCostCenter.description",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: "Új Telephely",
        value: "site.code",
        filterCol: "site.code",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: "Új Tlph Leírás",
        value: "site.description",
        filterCol: "site.description",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: "Új Ktsg Kód",
        value: "newCostCenter.code",
        filterCol: "newCostCenter.code",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: "Új Ktsg Leírás",
        value: "newCostCenter.description",
        filterCol: "newCostCenter.description",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: "Termékkód",
        value: "product.productCode",
        filterCol: "product.productCode",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: "Vonalkód",
        value: "product.barCode",
        filterCol: "product.barCode",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: "Termék Leírás",
        value: "product.description",
        filterCol: "product.description",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
      {
        text: "Típus",
        value: "historyType",
        filterCol: "historyType",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "enum"
      },
      {
        text: "Megjegyzés",
        value: "note",
        filterCol: "note",
        width: "1%",
        align: "left",
        filterable: true,
        filterType: "text"
      },
    ];
  }

  async created() {
    await this.getInventoryReports();
  }

  reload() {
    this.updatePagination(this.pagination);
  }

  changeSort(column) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
    this.updatePagination(this.pagination);
  }

  updatePagination(pagination) {
    (this as any).$cookies.set("inventory-reports-rowsPerPage", pagination.rowsPerPage);

    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
      filters: JSON.stringify(this.filters)  // Serialize filters to JSON string
    };
    this.getInventoryReports(page);
  }

  formatDate(date) {
    if (!date) { return ""; }
    return new Date(date).toLocaleDateString("hu-HU");
  }

  triggerFilter() {
    this.serversideSearch();
  }

  toggleFilters() {
    if (this.showFilters) {
      // If hiding filters, clear all filter criteria
      this.clearFilters();
    }
    this.showFilters = !this.showFilters;
  }

  clearFilters() {
    this.filters = {
      "createdDate": { from: "", to: "" },
      "origSite.code": "",
      "origSite.description": "",
      "origCostCenter.code": "",
      "origCostCenter.description": "",
      "site.code": "",
      "site.description": "",
      "newCostCenter.code": "",
      "newCostCenter.description": "",
      "product.description": "",
      "product.productCode": "",
      "product.barCode": "",
      "historyType": "",
      "note": ""
    };
    // Trigger search to refresh results without filters
    this.serversideSearch();
  }

  getHistoryTypeText(historyType) {
    switch (historyType) {
      case 0:
        return "Leltár";
      case 1:
        return "Törölve";
      case 2:
        return "Státusz változás";
      default:
        return "Ismeretlen";
    }
  }

  getHistoryTypeOptions() {
    return [
      { text: "Összes", value: "" },
      { text: "Leltár", value: 0 },
      { text: "Törölve", value: 1 },
      { text: "Státusz változás", value: 2 }
    ];
  }

  // Download method
  downloadInventoryReportData() {
    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: this.pagination.sortBy,
      descending: this.pagination.descending,
      page: this.pagination.page,
      rowsPerPage: this.pagination.rowsPerPage,
      searchString: x,
      filters: JSON.stringify(this.filters)
    };
    importExportApi.downloadInventoryReportExport(page, "Eszkozgatás SABLOMN.xlsx");
  }
}
